import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { errorInterceptor } from 'src/app/core';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withPreloading, withRouterConfig } from '@angular/router';
import { provideToastr } from 'ngx-toastr';
import { includeBearerTokenInterceptor, provideKeycloak } from 'keycloak-angular';
import { AppConfig } from './shared/utils/app-config.util';
import { initializeKeycloak } from './core/auth/keycloak.config';
import { routes } from './app.routes';

registerLocaleData(localeEs, 'es');

export function appConfig(config: AppConfig): ApplicationConfig {
  return {
    providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    provideKeycloak(initializeKeycloak(config)),
    provideHttpClient(
      withInterceptors([includeBearerTokenInterceptor, errorInterceptor])
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({ onSameUrlNavigation: 'ignore' }),
      withPreloading(PreloadAllModules)
    ),
    provideAnimations(),
    provideToastr({
      preventDuplicates: true,
      timeOut: 3000,
      positionClass: 'toast-top-right',
      progressBar: true,
    }),
  ],
};
}
